module.exports = __webpack_public_path__ + "img/natalia_rheskava.d84d2a99.jpeg";